<template>
  <div class="rework-bd" v-if="funcView.maintain_rework_list">
    <div class="ub" style="height: 100%">
      <div class="ub-f2 ubv">
        <div class="search-hd">
          <div class="item-title">{{ $t('asm_rework.cpfgbb') }}</div>
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item v-if="funcView.maintain_rework_add">
              <el-button type="primary" icon="el-icon-plus" @click="onGroupAdd()">{{ $t('Common.com_add') }}</el-button>
            </el-form-item>
            <el-form-item style="float: right; margin-right: 0">
              <search-input v-model="formSearch.search" width="200px" :placeholder="$t('asm_rework.ban_ben_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
            </el-form-item>
            <el-form-item style="float: right">
              <custom-select
                url="productCodeSelectList"
                v-model="formSearch.productCode"
                :props="{ label: 'productCode', value: 'productCode' }"
                width="100%"
                @change="onPageChange({ page: 1 })"
                :placeholder="$t('asm_rework.chan_pin_xing_hao')"
              ></custom-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table
            type="radio"
            v-model="itemGroup"
            height="100%"
            @change="onChangeTable"
            tableCode="rework_version"
            :data="tableList"
            @column="setColumn"
            @filter="filterChange"
            @sort="sortChange"
            :slots="['action', 'itemVersion']"
          >
            <template slot="itemVersion" slot-scope="scope">
              <div class="cell-link" @click="onGroupWatch(scope.row)">{{ scope.row.itemVersion }}</div>
            </template>
            <template v-slot:action="scope">
              <el-button v-if="!scope.row.isPublish && funcView.maintain_rework_edit" type="text" size="mini" @click="onGroupEdit(scope.row)">{{ $t('Common.com_edit') }}</el-button>
              <el-button v-if="!scope.row.isPublish && funcView.maintain_rework_publish" type="text" size="mini" @click="onPublish(scope.row, 1)">{{ $t('asm_rework.fa_bu') }}</el-button>
              <el-button v-if="!scope.row.isPublish && funcView.maintain_rework_delete" type="text" size="mini" @click="onGroupDelete(scope.row)">{{ $t('Common.com_delete') }}</el-button>
              <el-button v-if="scope.row.isPublish && funcView.maintain_rework_publish" type="text" size="mini" @click="onPublish(scope.row, 0)">{{ $t('asm_rework.che_xiao_fa_bu') }}</el-button>
            </template>
          </custom-table>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div>
      <div style="width: 1px; background-color: #ebeef5; margin: 0 16px"></div>
      <div class="ub-f3" style="overflow: hidden">
        <rework-item ref="reworkItem" :itemGroup="itemGroup"></rework-item>
      </div>
    </div>
    <rework-dialog v-if="dialog1Visible" @close="dialog1Visible = false" :model="dialog1Model" @success="onPageChange({ page: 1 })"></rework-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import reworkDialog from './rework_dialog.vue';
import reworkItem from './rework_item.vue';

export default {
  components: {
    reworkDialog,
    reworkItem,
  },
  data() {
    return {
      itemGroup: null,
      itemSelected: [],
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
      },
      totalRows: null,
      tableList: [],
      // 新增编辑项目
      dialog1Model: {},
      dialog1Visible: false,
    };
  },
  mounted() {
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.reworkItemGroupPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onChangeTable() {
      this.$refs.reworkItem.init();
    },
    // 发布
    onPublish(row, isPublish) {
      const tips = this.$t('asm_rework.nqdyooofgbbm', [!isPublish ? this.$t('Common.com_undo') : this.$t('asm_rework.fa_bu'),row.productCode,row.itemVersion]);
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.reworkPublish}/${row.itemGroupId}/${isPublish}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    // 新增
    onGroupAdd() {
      this.dialog1Model = {
        title: this.$t('asm_rework.xzfgbb'),
        type: 'add',
      };
      this.dialog1Visible = true;
    },
    // 编辑
    onGroupEdit(row) {
      this.dialog1Model = {
        title: this.$t('asm_rework.bjfgbb'),
        type: 'edit',
        row: row,
      };
      this.dialog1Visible = true;
    },
    // 查看
    onGroupWatch(row) {
      this.dialog1Model = {
        title: this.$t('asm_rework.ckfgbb'),
        type: 'watch',
        row: row,
      };
      this.dialog1Visible = true;
    },
    // 删除
    onGroupDelete(row) {
      this.$showConfirm(this.$t('asm_rework.nqdyscdqbbm'))
        .then(() => {
          this.$postJSON(`${apis.reworkItemGroupDelete}/${row.itemGroupId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.rework-bd {
  padding: 0 16px 0 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  // overflow-x: auto;
}
</style>
